import { Card, H1SectionTitle, SectionSubtitle } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import * as Styled from './styled';
import type { JoinBuyerPageProps } from './types';

export * from './types';

export const JoinBuyerPage: FC<JoinBuyerPageProps> = (props) => {
  const { formComponent, statusText, joinLink, onDismissMessageClick, showPostSignup } = props;
  const { translate } = useTranslation();

  return (
    <Styled.Wrapper>
      <Card size="small">
        <H1SectionTitle>{translate('signup.buyer.title')}</H1SectionTitle>
        <SectionSubtitle>{translate('signup.quote')}</SectionSubtitle>
        {showPostSignup ? (
          translate('signup.step2')
        ) : (
          <Styled.JoinMore>
            {translate('signup.buyer.notBuyer')}
            {'  '}
            <Link to={joinLink}>{translate('common.buttons.clickHere')}</Link>
          </Styled.JoinMore>
        )}
        {!!statusText && (
          <Styled.StatusText>
            {statusText}
            <Styled.DismissIconWrapper>
              {!!onDismissMessageClick && <FaTrash onClick={onDismissMessageClick} />}
            </Styled.DismissIconWrapper>
          </Styled.StatusText>
        )}
        {formComponent}
      </Card>
    </Styled.Wrapper>
  );
};
